import type { CollectedLink } from './collectLinks';
import type { LinkActionProps } from './inlineA11y';

export type { LinkActionProps };

/** The DOM announces an inline link in place; it needs no action on its block. */
export function linkActionProps(_links: CollectedLink[]): LinkActionProps {
	return {};
}
